module.exports = __webpack_public_path__ + "media/bootstrap-icons/person-x-310a291f.svg";